import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../hooks/auth/useAuth";
import { authContextType } from "../@types/auth-types";
import { useStudentsData } from "../hooks/student/useStudentsData";
import { useHeroesData } from "../hooks/hero/useHeroesData";
import BackgroundLogo from "../components/background-logo";
import { BsGearFill } from "react-icons/bs";
import "../styles/pages/new-student.css";
import api from "../util/api";

function EditStudent() {
  const navigate = useNavigate();
  const { studentId } = useParams();
  const { user } = useAuth() as authContextType;
  const { data: students } = useStudentsData(user.teacherId, user.token);
  const { data: heroes } = useHeroesData(user.token);

  const [nome, setNome] = useState("");
  const [code, setCode] = useState("");
  const [hero, setHero] = useState("");
  const [stage, setStage] = useState("");
  const [vowel, setVowel] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const vogais = ["A", "E", "I", "O", "U"];
  const estagios = ["Sílaba", "Vogal", "Frase", "Texto"];

  useEffect(() => {
    const student = students?.find(s => s.id === studentId);
    if (student) {
      setNome(student.name);
      setCode(student.code || "");
      setHero(student.hero?.id || "");
      setStage(student.stage || "");
      setVowel(student.vowel || "");
    }
  }, [students, studentId]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    if (code.length < 4) {
      setError("Código do aluno deve ter no mínimo 4 caracteres");
      setIsLoading(false);
      return;
    }

    try {
      api.defaults.headers.authorization = user.token;

      await api.patch(`/aluno/${studentId}`, {
        name: nome,
        code: code,
        heroId: hero,
        stage: stage,
        vowel: vowel
      });

      navigate("/alunos");
    } catch (err: any) {
      const message = err.response?.status === 403
        ? "Não autorizado. Por favor, faça login novamente."
        : "Erro ao atualizar aluno";
      setError(message);
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleComeBack = () => {
    navigate("/alunos");
  };

  return (
    <div className="background-new-student">
      <BackgroundLogo isAdminPage={false} />
      <div className="background-right-new-student">
        <div className="content-new-student">
          <label className="label-title-new-student">Editar Aluno</label>

          <label className="label-new-student">Nome</label>
          <input
            type="text"
            name="nome"
            className="input-new-student"
            placeholder="Digite o Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />

          <label className="label-new-student">Herói</label>
          <select
            className="input-new-student"
            required
            value={hero}
            onChange={(e) => setHero(e.target.value)}
          >
            <option value="" disabled>
              Selecione...
            </option>
            {heroes?.map((heroi) => (
              <option key={heroi.id} value={heroi.id}>
                {heroi.name}
              </option>
            ))}
          </select>

          <label className="label-new-student">Vogal</label>
          <select
            className="input-new-student"
            required
            value={vowel}
            onChange={(e) => setVowel(e.target.value)}
          >
            <option value="" disabled>
              Selecione...
            </option>
            {vogais.map((vogal) => (
              <option key={vogal} value={vogal}>
                {vogal}
              </option>
            ))}
          </select>

          <label className="label-new-student">Estágio</label>
          <select
            className="input-new-student"
            required
            value={stage}
            onChange={(e) => setStage(e.target.value)}
          >
            <option value="" disabled>
              Selecione...
            </option>
            {estagios.map((estagio, index) => (
              <option key={estagio} value={estagio}>
                {index + 1 + " - " + estagio}
              </option>
            ))}
          </select>

          <label className="label-new-student">Código do aluno</label>
          <input
            type="text"
            name="code"
            className="input-new-student"
            placeholder="Digite o Código do aluno"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />

          {error && <label className="label-error-new-student">{error}</label>}
          <div className="buttons-container-new-student">
            <input
              type="button"
              value="Voltar"
              className="button-go-back-new-student"
              onClick={handleComeBack}
            />
            <input
              type="submit"
              value={isLoading ? "Salvando..." : "Salvar"}
              className="button-new-student"
              onClick={handleSubmit}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditStudent;